import script from "./Toasts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Toasts.vue?vue&type=script&setup=true&lang=ts"

import "./Toasts.vue?vue&type=style&index=0&id=3efb957e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3efb957e"]])

export default __exports__